module.exports = __webpack_public_path__ + "img/state07.5a3cc7e7.png";